let rootUrl;

if(window.location.origin === 'http://localhost:3000') {
    // rootUrl = 'https://portal.vmedulife.com'; 
    rootUrl = 'http://localhost';
}else {
    rootUrl = "https://" + window.location.host;
}

export default {
    RootUrl: rootUrl,
};